export default {
	mounted() {
		this.$scrollTo(this.$el);
	}
};
